/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class StartSqlQueryExecutionInput {
  /**
  * The ID of the SQL engine to run the query on
  */
  'sqlEngineId': string;
  /**
  * The SQL query text to execute
  */
  'query': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sqlEngineId",
      "baseName": "sqlEngineId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StartSqlQueryExecutionInput.attributeTypeMap;
  }

  public constructor() {
  }
}

